/**
 * 按钮级权限控制模块
 * 通过菜单树中 type=B(按钮) 节点的 permit keyword 字段，控制按钮显隐
 *
 * 使用方式：
 *   指令：<el-button v-permit="'order:export'">导出</el-button>
 *   函数：<el-button v-if="hasPermission('order:export')">导出</el-button>
 *   多关键字（任一满足即显示）：<el-button v-permit="['role:edit','role:delete']">操作</el-button>
 */

// 存储当前用户拥有的权限 keyword 集合
let permissionSet = new Set()

/**
 * 设置权限 keyword 集合
 * @param {Array} list - 扁平化的菜单列表（需包含 type 和 permit 字段）
 */
export function setPermissions(list = []) {
  permissionSet = new Set(
    list
      .filter(m => m.type === 'B' && m.permit)
      .map(m => m.permit)
  )
  // 缓存到 localStorage，刷新后可从缓存恢复避免首屏闪烁
  try {
    localStorage.setItem('PERMISSION_KEYWORDS', JSON.stringify([...permissionSet]))
  } catch (e) {
    // ignore
  }
}

/**
 * 判断是否拥有某个权限 keyword
 * @param {string} keyword - 权限关键字
 * @returns {boolean}
 */
export function hasPermission(keyword) {
  if (!keyword) return true // 未配置 keyword 的按钮默认显示
  return permissionSet.has(keyword)
}

/**
 * 判断是否拥有任一权限 keyword
 * @param {string[]} keywords - 权限关键字数组
 * @returns {boolean}
 */
export function hasAnyPermission(keywords = []) {
  return keywords.some(k => hasPermission(k))
}

/**
 * 从 localStorage 恢复权限缓存（应用启动时调用，避免首屏闪烁）
 */
export function restorePermissions() {
  try {
    const raw = localStorage.getItem('PERMISSION_KEYWORDS')
    if (raw) {
      permissionSet = new Set(JSON.parse(raw))
    }
  } catch (e) {
    // ignore
  }
}

/**
 * 清除权限缓存（退出登录时调用）
 */
export function clearPermissions() {
  permissionSet = new Set()
  try {
    localStorage.removeItem('PERMISSION_KEYWORDS')
  } catch (e) {
    // ignore
  }
}
